import { env, type ENV } from "@monta/env";

export const fixString = (s: string, baseURL?: keyof ENV) => {
  if (!baseURL) return s;
  const hasBaseURL = /^https?:\/\//i.test(s);
  if (hasBaseURL) return s;
  return `${env[baseURL]}${s}`;
};
